import React, { Dispatch } from 'react';

export interface LedgerContextType {
  selected: number[];
  visibleColumns: any[];
  data: any[] | null;
  clearSelect: () => void;
  updateVisibleColumns: Dispatch<any>;
}

export const initialSelected: number[] = [];
export const initialVisibleColumns: any[] = [];
export const initialData: any[] = [];
export const initialUpdateVisibleColumns: Dispatch<any> = () => {};
export const initialClearSelect: () => void = () => {};

const LedgerContext = React.createContext<LedgerContextType>({
  selected: initialSelected,
  visibleColumns: initialVisibleColumns,
  data: initialData,
  clearSelect: initialClearSelect,
  updateVisibleColumns: initialUpdateVisibleColumns,
});

export default LedgerContext;
